module.exports = __webpack_public_path__ + "images/df458dcb.jpg";